import React from 'react'

// MATERIAL UI STUFF
import Typography from '@material-ui/core/Typography'


export default class SimpleParagraphWButton extends React.Component {
	render(){
		return(
			<div className="MainDiv">
				<Typography style={{fontWeight: 500, opacity: 1, color: `${this.props.colorTitle}`}} gutterBottom variant="display1">{this.props.title}</Typography>
                <Typography style={{opacity: .8, fontWeight: 500, lineHeight: '1.2em', color: `${this.props.colorSubtitle}`}} gutterBottom variant="headline">{this.props.subtitle}</Typography>
                <a href={this.props.text} target='_blank' style={{textDecoration: 'none'}}>
                </a>
			</div>
			)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Utilities/PortfolioTitle.js